export function buttonItem(buttonItem) {
  const clickableElement = buttonItem.querySelector(".content");
  const elementDescription = buttonItem.querySelector(".description");

  $(elementDescription).hide();

  clickableElement.addEventListener("click", function () {
    buttonItem.classList.toggle("is-active");

    const hasActiveClass = buttonItem.classList.contains("is-active");

    if (hasActiveClass) {
      $(elementDescription).hide();
    }

    for (let sibling of buttonItem
      .closest(".button-reveal-list")
      .querySelectorAll(".button-reveal-item")) {
      if (sibling !== buttonItem) {
        sibling.classList.remove("is-active");

        const siblingDescription = sibling.querySelector(".description");
        $(siblingDescription).hide("slow");
      } else {
        const siblingDescription = sibling.querySelector(".description");
        $(siblingDescription).show("slow");
      }
    }
  });
}

export default function ButtonReveal() {
  document.querySelectorAll(".button-reveal-item").forEach(function (item) {
    buttonItem(item);
  });
}
